import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getUsers = () => {
  return axios
  .get(API_URL + "Users", { headers: authHeader() })
  .then((response) => {
    return response.data;
  });
};

const putUser = (user) => {
  return axios
  .put(API_URL + "Users/UpsertUser/" + user.id, user)
  .then((response) => {
    return response.data;
  }).catch((error)=> {
  });
};

const deleteUser = (id) => {
  return axios
  .delete(API_URL + "Users/" + id)
  .then((response) => {
    return response.status;
  });
};

export default {
    getUsers,
    putUser,
    deleteUser
};